import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DatatableComponent, SelectionType, ColumnMode } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';

import { IssuePopulateService, MessagesService } from '../../../services/api.services';
import { IssueFront, FuturaLineaProformaFront } from '../../../models/api.models';

import { IssueProformableData } from '../issue.proformable.data';
import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { SendClickEventEmitter } from '../send.click.event.emitter';


@Component({
  selector: 'app-issues-proformables-escritorio',
  templateUrl: './issues-proformables-escritorio.component.html',
  styleUrls: ['./issues-proformables-escritorio.component.scss'],
})
export class IssuesProformablesEscritorioComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;

  @Input() issueProformableData: IssueProformableData;
  @Input() proformasToCreate: FuturaLineaProformaFront[];

  @Output() rowSelected = new EventEmitter();
  @Output() nextClicked = new EventEmitter();

  resetRowsSelectedSubscription: Subscription;
  rows: IssueFront[] = [];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selected = [];

  showNextButton = false;

  crearProformableNextClick: SendClickEventEmitter = new SendClickEventEmitter();

  constructor(private messages: MessagesService,
              private modalCtrl: ModalController,
              private issuePopulateService: IssuePopulateService) { }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      if (this.issueProformableData != null) {
        if (this.proformasToCreate.length > 0) {
          const issuesFrontSelect: IssueFront[] = [];
          this.proformasToCreate.forEach((proformaToCreate, index) => {
            issuesFrontSelect.push(proformaToCreate.issueFrontAsociada);
          });
          this.autocheckIssuesToProformable(issuesFrontSelect);
          this.rows = issuesFrontSelect;
          this.showNextButton = true;
        } else {
          this.rows = this.issueProformableData.issuesFront;
          this.showNextButton = false;
        }
      }
    });
  }

  autocheckIssuesToProformable(issuesFrontSelect: IssueFront[]) {
    this.selected = issuesFrontSelect;
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  displayCheck(row) {
    return row.has_agreement !== 0;
  }

  siguiente() {
    const toSend: SendClickEventEmitter = new SendClickEventEmitter();
    toSend.clicked = true;
    toSend.tabla = 'issues-proformables-escritorio';
    toSend.proformasToCreate = this.proformasToCreate;
    this.nextClicked.emit(toSend);
  }

  onActivate(event) {}

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    const nextProformasToCreate: FuturaLineaProformaFront[] = [];
    this.selected.forEach((issueFront, index) => {
      if (this.issuePopulateService.isIssueFrontProformable(issueFront)) {
        const proformaLinesExistentes = this.proformasToCreate.filter(proformaLine => proformaLine.issueFrontAsociada.id === issueFront.id);
        if (proformaLinesExistentes.length <= 0) {
          nextProformasToCreate.push({
            issueFrontAsociada: issueFront,
            manoObra: null,
            material: null,
            rowIndex: index,
          });
        } else {
          nextProformasToCreate.push(proformaLinesExistentes[0]);
        }
      }
    });
    this.proformasToCreate.splice(0, this.proformasToCreate.length);
    this.proformasToCreate.push(...nextProformasToCreate);
    // this.proformasToCreate = nextProformasToCreate;
    if (this.proformasToCreate.length > 0) {
      this.showNextButton = true;
    } else {
      this.showNextButton = false;
    }
  }

  getRowIndex(row: any): number {
    let num = -1;
    this.rows.forEach((issue, k) => {
      if (issue.id === row.id) {
        num = k;
        return;
      }
    });
    return num;
  }

  getHeaderClass({ row, column, value }): any {}

  getCellClass({ row, column, value }): any {}

}
